import React, { useCallback, useEffect, useMemo, useState } from 'react';
import IEditorOptions from "../../models/IEditorOptions";
import { SelectBox } from "devextreme-react/select-box";
import ICustomSelectBoxData from "../../models/ICostumSelectBoxData";
function useSexe() {
  const sexe: ICustomSelectBoxData[] = [{ id: "-", description: "Indéterminé" }, { id: "M", description: "Homme" }, { id: "F", description: "Femme" }];
  const [currentSelectedItem, setCurrentSelectedItem] = useState<ICustomSelectBoxData>();


  const editorOptions = useMemo((): IEditorOptions<ICustomSelectBoxData[]> => {
    return {
      searchEnabled: true,
      dataSource: sexe,
      displayExpr: "description",
      displayValue: "id",
      valueExpr: "id",
    }
  }, [sexe])

  const SexeSelectBox = useCallback((params: any) => {
    const { dataField, component, column, data } = params;
    const formOptions = component.option();
    const value = dataField ? formOptions.formData[dataField] : data[column.dataField];

    const onValueChanged = (args: any) => {
      component.updateData(dataField, args.value);
    }

    const onSelectionChanged = (e: any) => {
      setCurrentSelectedItem(e.selectedItem);
    }

    return (
      <SelectBox readOnly={formOptions.readOnly} onSelectionChanged={onSelectionChanged} dataSource={editorOptions.dataSource} displayExpr={editorOptions.displayExpr} displayValue={editorOptions.displayValue} valueExpr={editorOptions.valueExpr} value={value} onValueChanged={onValueChanged} />
    )
  }, [editorOptions, currentSelectedItem]);

  return {
    sexeEditorOptions: editorOptions,
    sexe,
    currentSexe: currentSelectedItem,
    SexeSelectBox
  }
}

export default useSexe;